import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { statApi } from '@/api/index';
import type {
  AggrDeviceBody,
  AggrDeviceFieldAggrBody,
  AggrDeviceFieldThrBody,
  AggrPlaysBody,
  AggrTotalPlaysByAdBody,
  TabletRidesByDayBody,
} from '@/api/routes/stat/types';

export const fetchAggrDevice = createAsyncThunk(
  'stat/aggr/device',
  async (payload: AggrDeviceBody, thunkAPI) => {
    try {
      const response = await statApi.getDevice(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchAggrDeviceTimeFieldThr = createAsyncThunk(
  'stat/aggr/device-field-thr-time',
  async (payload: AggrDeviceFieldThrBody, thunkAPI) => {
    try {
      const response = await statApi.getDeviceByField(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchAggrDeviceMileageFieldThr = createAsyncThunk(
  'stat/aggr/device-field-thr-mileage',
  async (payload: AggrDeviceFieldThrBody, thunkAPI) => {
    try {
      const response = await statApi.getDeviceByField(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchAggrDeviceSumFieldAggr = createAsyncThunk(
  'stat/aggr/device-field-aggr-sum',
  async (payload: AggrDeviceFieldAggrBody, thunkAPI) => {
    try {
      const response = await statApi.getDeviceByAggr(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
export const fetchAggrDeviceSumAdTimeFieldAggr = createAsyncThunk(
  'stat/aggr/device-field-aggr-sum-ad-time',
  async (payload: AggrDeviceFieldAggrBody, thunkAPI) => {
    try {
      const response = await statApi.getDeviceByAggr(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchAggrDeviceAvgFieldAggr = createAsyncThunk(
  'stat/aggr/device-field-aggr-avg',
  async (payload: AggrDeviceFieldAggrBody, thunkAPI) => {
    try {
      const response = await statApi.getDeviceByAggr(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchAggrPlaysByDay = createAsyncThunk(
  'stat/aggr/plays-by-day',
  async (payload: AggrPlaysBody, thunkAPI) => {
    try {
      const response = await statApi.getPlaysByDay(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchAggrPlaysByAd = createAsyncThunk(
  'stat/aggr/plays-by-ad',
  async (payload: AggrPlaysBody, thunkAPI) => {
    try {
      const response = await statApi.getPlaysByAd(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchAggrTotalPlaysByAd = createAsyncThunk(
  'stat/aggr/total-plays-by-ad',
  async (payload: AggrTotalPlaysByAdBody, thunkAPI) => {
    try {
      const response = await statApi.getTotalPlaysByAd(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchTabletRidesByDay = createAsyncThunk(
  'stat/aggr/tablet-rides-by-day',
  async (payload: TabletRidesByDayBody, thunkAPI) => {
    try {
      const response = await statApi.getTabletRidesByDay(payload);
      return response ? response.data : { count: [], duration: [] };
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
